import { Pipe, PipeTransform } from '@angular/core';
import { ARR_TYPE_EMPLOYER } from '../config/employer-type.enum';
 
@Pipe({
  name: 'employerTypeColor'
})
export class EmployerTypeColorPipe implements PipeTransform {

  transform(value: string): string {

    const ix = ARR_TYPE_EMPLOYER.findIndex(x => x.text === value);

    return ix === -1? '' : ARR_TYPE_EMPLOYER[ix].color;
  }
}